import React, { useState, useEffect } from "react";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import { useLocation } from "react-router-dom/dist";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import { Showalert } from "../../../../customComponents/CustomSweetAlert/SweetAlert";

const AddNewLeadPresales = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [leadPriorityOptions, setLeadPriorityOptions] = useState([]);
  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [BusinessPartneroptions, setBusinessPartneroptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const business_partner_id = localStorage?.getItem("business_partner_id");
  const userType = localStorage?.getItem("UserType");
  const token = localStorage.getItem("authToken");
  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "businesspartnername",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: BusinessPartneroptions,
            gridClass: "col-lg-4",
            validation: {
              required: true,
            },
          },
        ]
      : []),
    // {
    //   name: "title",
    //   label: "Title",
    //   type: "dropdown",
    //   required: true,
    //   options: [],
    //   gridClass: "col-lg-4",
    // },
    {
      name: "leadsource",
      label: "Lead Source",
      type: "dropdown",

      required: true,
      options: [],
      gridClass: "col-lg-4",
    },

    {
      name: "leadpriority",
      label: "Lead Priority",
      type: "dropdown",
      required: true,
      validation: { required: true },
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "firstname",
      label: "First Name",
      type: "text",
      placeholder: "Enter First Name",
      required: true,
      validation: {
        required: true,
        pattern:  /^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/,
        message: "Invalid First Name",
        maxLength: 25,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "lastname",
      label: "Last Name",
      type: "text",
      placeholder: "Enter Last Name",
      required: true,
      validation: {
        required: true,
        pattern:  /^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/,
        message: "Invalid Last Name",
        maxLength: 25,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "mobile",
      label: "Mobile No.",
      type: "text",
      placeholder: "Enter Mobile No.",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      },

      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "altmobile",
      label: "Alternate Mobile No.",
      type: "text",
      placeholder: "Enter Alternate Mobile No.",
      validation: { 
        required: true, pattern: /^[6-9]/ ,
        minLength:10,
        maxLength:10,
        message1: "Contact no should start with 6, 7, 8, 9",
        message: "Please enter a valid 10-digit",
      },

      required: false,
      gridClass: "col-lg-4",
      isVisible: false,
    },
    {
      name: "email",
      label: "Email Address",
      type: "text",
      placeholder: "Enter Email Address",
      validation: {
       // required: true,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Please enter a valid Email Address",
      },
      required: false,
      gridClass: "col-lg-4",
    },
    {
      name: "productname",
      label: "Product",
      type: "dropdown",
      required: true,
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "vehiclename",
      label: "Vehicle Name(Variant type)",
      type: "dropdown",
      required: false,
      options: [],
      gridClass: "col-lg-4",
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Remark",
      required: true,
      gridClass: "col-lg-4",
    },
  ];
  useEffect(() => {
    if (location.state) {
      const { searchType, searchQuery } = location.state;

      switch (searchType) {
        case 1:
          setFormData((prevData) => ({ ...prevData, firstname: searchQuery }));
          break;
        case 2:
          setFormData((prevData) => ({ ...prevData, mobile: searchQuery }));
          break;
        case 3:
          setFormData((prevData) => ({ ...prevData, email: searchQuery }));
          break;
        default:
          break;
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (formData?.businesspartnername) {
      const fetchOptions = async () => {
        try {
          const token = localStorage.getItem("authToken");

          const leadSourceResponse = await axiosInstance.post(
            "/source/ddlsource",
            {
              business_partner_id:
                formData?.businesspartnername || business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const options = leadSourceResponse.data.data.data?.map((source) => ({
            label: source.NAME,
            value: source.ID,
          }));

          setLeadSourceOptions(options);

          const leadPriorityResponse = await axiosInstance.post(
            "/priority/ddlpriority",
            {
              business_partner_id:
                formData?.businesspartnername || business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const priorityoptions = leadPriorityResponse.data.data.data?.map(
            (priority) => ({
              label: priority.NAME,
              value: priority.ID,
            })
          );

          setLeadPriorityOptions(priorityoptions);

          const productResponse = await axiosInstance.post(
            "/product/ddlproduct",
            {
              business_partner_id:
                formData?.businesspartnername || business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const productOptions = productResponse.data.data.data?.map(
            (product) => ({
              label: product.NAME,
              value: product.ID,
            })
          );
          setProductOptions(productOptions);
        } catch (error) {
          console.error("Error fetching options:", error);
        }
      };

      fetchOptions();
    }
  }, [formData?.businesspartnername]);

  useEffect(() => {
    if (userType != "superadmin" && business_partner_id) {
      const fetchOptions = async () => {
        try {
          const leadSourceResponse = await axiosInstance.post(
            "/source/ddlsource",
            {
              business_partner_id:
                formData?.businesspartnername || business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const options = leadSourceResponse.data.data.data?.map((source) => ({
            label: source.NAME,
            value: source.ID,
          }));

          setLeadSourceOptions(options);

          const leadPriorityResponse = await axiosInstance.post(
            "/priority/ddlpriority",
            {
              business_partner_id:
                formData?.businesspartnername || business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const priorityoptions = leadPriorityResponse.data.data.data?.map(
            (priority) => ({
              label: priority.NAME,
              value: priority.ID,
            })
          );

          setLeadPriorityOptions(priorityoptions);

          const productResponse = await axiosInstance.post(
            "/product/ddlproduct",
            {
              business_partner_id:
                formData?.businesspartnername || business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const productOptions = productResponse.data.data.data?.map(
            (product) => ({
              label: product.NAME,
              value: product.ID,
            })
          );
          setProductOptions(productOptions);
        } catch (error) {
          console.error("Error fetching options:", error);
        }
      };

      fetchOptions();
    }
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make the API call for BusinessPartnerResponse
        const businessPartnerResponse = await axiosInstance.get(
          "/bp-onboard/bplist",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Process BusinessPartnerResponse data
        console.log(businessPartnerResponse, "businessPartnerResponse");

        const Businessoptions = businessPartnerResponse.data.data?.data?.map(
          (customer) => ({
            label: customer.bp_name,
            value: customer.onboard_id,
          })
        );
        console.log("businessoptions", Businessoptions);

        setBusinessPartneroptions(Businessoptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the async function
    fetchData();

    // Specify dependencies (add dependencies based on what should trigger this effect)
  }, []); // Dependency array

  useEffect(() => {
    if (formData.productname) {
      const fetchVariantOptions = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post(
            "/variant/ddlvariant",
            {
              business_partner_id:
                formData?.businesspartnername || business_partner_id,
              product_id: formData.productname,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const variantOptions = response.data.data.data?.map((variant) => ({
            label: variant.NAME,
            value: variant.ID,
          }));

          setVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantOptions();
    }
  }, [formData.productname]);
  const handleFormSubmit = async (data) => {
    console.log("FormData:", data);
    const errors = {};
    let isValid = true;
  
    // Form validation logic
    CustomerInputs.forEach((field) => {
      console.log("field>>", field);
      if (field.required && !data[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(data[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    // If validation fails, stop form submission
    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors", validationErrors);
      return;
    }
  
    // Confirmation alert before submitting
    Showalert({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      callback: async () => {
        setIsLoading(true); // Set loading to true after confirmation
  
        try {
          const token = localStorage.getItem("authToken");
  
          // Send API request to create a new lead
          const response = await axiosInstance.post(
            "/lead/newleadcreate",
            {
              business_partner_id: data?.businesspartnername || business_partner_id,
              source_id: data?.leadsource,
              priority_id: data?.leadpriority,
              first_name: data?.firstname,
              last_name: data?.lastname,
              status_id: 1,
              email_id: data?.email,
              product_id: data?.productname,
              variant_id: data?.vehiclename,
              mobile_no: data?.mobile,
              remarks: data?.remark,
              //status: data?.status,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          console.log("API Response:", response.data);
  
          // Success SweetAlert with dynamic message
          Swal.fire({
            title: "Success",
            text: "Lead added successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate(ROUTES_NAVIGATION.ADVANCESEARCH); // Navigate after user clicks OK
          });
  
        } catch (error) {
          console.error("Error submitting form:", error.response?.data?.message || "Failed to add the lead.");
  
          // Error SweetAlert with dynamic message
          Swal.fire({
            title: "Error",
            text: error.response?.data?.message || "Failed to add the lead. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setIsLoading(false); // Reset loading state after operation
        }
      },
    });
  };
  
  
  // const handleFormSubmit = async (data) => {
  //   console.log("FormData:", data);
  //   const errors = {};
  //   let isValid = true;

  //   CustomerInputs.forEach((field) => {
  //     console.log("field>>", field);
  //     if (field.required && !formData[field.name]) {
  //       errors[field.name] = "This field is required";
  //       isValid = false;
  //     } else if (
  //       field.required &&
  //       field.validation &&
  //       field.validation.pattern &&
  //       !field.validation.pattern.test(formData[field.name])
  //     ) {
  //       errors[field.name] = field.validation.message;
  //       isValid = false;
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     console.log("validationErrors", validationErrors);
  //     return;
  //   }

  //   setIsLoading(true);

  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const response = await axiosInstance.post(
  //       "/lead/newleadcreate",
  //       {
  //         business_partner_id:
  //           formData?.businesspartnername || business_partner_id,
  //         source_id: data?.leadsource,
  //         priority_id: data?.leadpriority,
  //         first_name: data?.firstname,
  //         last_name: data?.lastname,
  //         status_id: 1,
  //         email_id: data?.email,
  //         product_id: data?.productname,
  //         variant_id: data?.vehiclename,
  //         mobile_no: data?.mobile,
  //         remarks: data?.remark,
  //         status: 1,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     console.log("API Response:", response.data);

  //     showCustomAlert({
  //       title: "Success",
  //       text: "Are you sure you want to add this record?",
  //       confirmButtonText: "Lead added successfully.",
  //       icon: "success",
  //       confirmButtonText: "OK",
  //       callback: () => {
  //         navigate(ROUTES_NAVIGATION.ADVANCESEARCH); // Navigate after user clicks OK
  //       },
  //     });
  //   } catch (error) {
  //     // toastError(error.response.data.message)
  //     console.error("Error submitting form:", error.response.data.message);
  //   }
  // };

  return (
    <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add New Lead</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Lead Details
        </span>

        <DynamicForm
          formConfig={CustomerInputs.filter((input) => {
            if (input.name === "altmobile") {
              return formData.leadsource === 2; // Include 'altmobile' only if leadsource is 2
            }
            return true; // Include all other inputs
          }).map((input) => {
            if (input.name === "leadsource") {
              return { ...input, options: leadSourceOptions };
            }
            if (input.name === "leadpriority") {
              return { ...input, options: leadPriorityOptions };
            }
            if (input.name === "productname") {
              return { ...input, options: productOptions };
            }
            if (input.name === "vehiclename") {
              return { ...input, options: variantOptions };
            }
            if (input.name === "altmobile") {
              console.log("leadsourceformdata", formData);
              return {
                ...input,
                isVisible: formData.leadsource === 2, // Check if leadsource is 'ref'
              };
            }
            return input;
          })}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          showParentDesignation={showParentDesignation}
        />

        {/* <DynamicForm
          formConfig={CustomerInputs.map(input => {
            if (input.name === "leadsource") {
              return { ...input, options: leadSourceOptions };
            }
            if (input.name === "leadpriority") {
              return { ...input, options: leadPriorityOptions };
            }
            if (input.name === "productname") {
              return { ...input, options: productOptions };
            }
            if (input.name === "vehiclename") {
              return { ...input, options: variantOptions };
            }
            if (input.name === "altmobile") {
              console.log("leadsourceformdata",formData);
              return {
                ...input,
                isVisible: formData.leadsource ===2, // Check if leadsource is 'ref'
              };
            }
            return input;
          })}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          showParentDesignation={showParentDesignation}
        /> */}
      </div>

      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            handleFormSubmit(formData);
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddNewLeadPresales;
